<div class="accordion" [class.collapsed]="collapse">
  <div class="accordion-header" (click)="onclick()">
    <div class="accordion-heading">
      <div class="header-text-field">
        @if (helpText) {
          <app-help-text [dataContext]="helpText" />
        }
        <span class="header-text">{{ header | translate }}</span>
      </div>
      <div class="header-badges">
        @if (counter) {
          <span class="badge badge--digit" [ngClass]="{ 'badge--smaller': counter > 9 }">{{
            counter > 9 ? '9+' : counter
          }}</span>
        }
        @if (indicator) {
          <span class="badge badge--exists"></span>
        }
      </div>
    </div>
    <button class="btn btn-expand" type="button"></button>
  </div>
  <div class="contentPane">
    <ng-content></ng-content>
  </div>
</div>
